import React from 'react';
import { Flex, Box } from 'theme-ui';
import { Button, Icon, VisuallyHidden, LUMOS_ONLY_SELECT, Card, ButtonLink, Menu } from '@loanpal/lumos__core';
import { useTable, useSortBy, usePagination, useRowSelect } from 'react-table';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var pageOptions = [{
  name: '10',
  value: '10'
}, {
  name: '20',
  value: '20'
}, {
  name: '30',
  value: '30'
}, {
  name: '40',
  value: '40'
}, {
  name: '50',
  value: '50'
}];

var Pagination = function Pagination(_ref) {
  var canPreviousPage = _ref.canPreviousPage,
      previousPage = _ref.previousPage,
      canNextPage = _ref.canNextPage,
      pageCount = _ref.pageCount,
      pageIndex = _ref.pageIndex,
      pageSize = _ref.pageSize,
      nextPage = _ref.nextPage,
      setPageSize = _ref.setPageSize,
      _ref$slimMode = _ref.slimMode,
      slimMode = _ref$slimMode === void 0 ? false : _ref$slimMode;
  var desktopOnly = slimMode ? {
    display: 'none'
  } : {
    display: ['none', 'block']
  };
  var mobileOnly = slimMode ? {
    display: 'block'
  } : {
    display: ['block', 'none']
  };
  var buttonPadding = slimMode ? 0 : [0, 3];
  var selectedPage = pageOptions.find(function (x) {
    return pageSize.toString() === x.value;
  });
  return React.createElement(Flex, {
    sx: {
      alignItems: 'center',
      mt: 1
    }
  }, React.createElement(Button, {
    variant: "ghost",
    onClick: previousPage,
    disabled: !canPreviousPage,
    sx: {
      pl: 0,
      pr: buttonPadding,
      mr: 1
    }
  }, React.createElement(Icon, {
    variant: "angle-left",
    size: "sm",
    sx: {
      transform: 'translateY(-1px)'
    }
  }), React.createElement(Box, {
    sx: desktopOnly
  }, "Previous", React.createElement(VisuallyHidden, null, "Page")), React.createElement(VisuallyHidden, {
    sx: mobileOnly
  }, "Previous Page")), React.createElement(Box, {
    variant: "inputContainer.description",
    sx: _extends(_extends({}, desktopOnly), {}, {
      mx: 2
    })
  }, "Page ", pageIndex + 1, " of ", pageCount), React.createElement(Button, {
    variant: "ghost",
    onClick: nextPage,
    disabled: !canNextPage,
    sx: {
      pl: buttonPadding,
      pr: 0,
      ml: 1
    }
  }, React.createElement(Box, {
    sx: desktopOnly
  }, "Next", React.createElement(VisuallyHidden, null, "Page")), React.createElement(VisuallyHidden, {
    sx: mobileOnly
  }, "Next Page"), React.createElement(Icon, {
    variant: "angle-right",
    size: "sm",
    sx: {
      transform: 'translateY(-1px)'
    }
  })), !slimMode && React.createElement(LUMOS_ONLY_SELECT, {
    sx: {
      mt: -1,
      ml: 'auto'
    },
    label: "Number of items per page",
    selectedValueItem: selectedPage,
    name: "paging",
    onChange: function onChange(item) {
      item ? setPageSize(Number.parseInt(item.value, 10)) : setPageSize(20);
    },
    items: pageOptions
  }));
};

var TableHeader = function TableHeader(_ref) {
  var column = _ref.column,
      compact = _ref.compact,
      cardTable = _ref.cardTable;
  var rotationDeg = column.isSortedDesc ? 'rotate(0deg)' : 'rotate(180deg)';
  var iconType = column.isSorted ? 'sort-selected' : 'sort';
  var sortProps = column.getSortByToggleProps();
  var headerProps = column.getHeaderProps(sortProps);
  var transformation = column.isSorted ? "translateY(5px) " + rotationDeg : 'translateY(5px)';
  return React.createElement(Box, Object.assign({
    as: "th",
    variant: !cardTable ? '' : 'text.small',
    sx: {
      // @ts-ignore
      textAlign: column.textAlign,
      // @ts-ignore
      fontWeight: 600,
      // @ts-ignore
      py: compact ? 1 : cardTable ? 3 : 2,
      // @ts-ignore
      px: compact ? 1 : cardTable ? 3 : 2,
      // @ts-ignore
      whiteSpace: 'nowrap',
      // @ts-ignore
      mb: !cardTable ? '' : -3,
      // @ts-ignore
      borderBottom: !cardTable ? '1px solid' : '',
      // @ts-ignore
      borderTop: !cardTable ? '' : '1px solid',
      // @ts-ignore
      borderColor: !cardTable ? 'neutral.l1' : 'neutral.l3'
    }
  }, headerProps), column.render('Header'), column.canSort && React.createElement(Icon, {
    variant: iconType,
    size: "sm",
    sx: {
      ml: '1px',
      transform: transformation,
      color: column.isSorted ? 'neutral.base' : 'neutral.l2',
      mt: -5
    }
  }));
};

var TableCell = function TableCell(_ref) {
  var compact = _ref.compact,
      cell = _ref.cell;
  return React.createElement(Box, Object.assign({
    as: "td",
    p: compact ? 1 : 2
  }, cell.getCellProps(), {
    sx: {
      // @ts-ignore
      borderBottom: '1px solid',
      // @ts-ignore
      borderColor: 'neutral.l3',
      // @ts-ignore
      textAlign: cell.column.textAlign,
      // @ts-ignore
      whiteSpace: 'nowrap'
    }
  }), cell.render('Cell'));
};

var IndeterminateCheckbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
      rest = _objectWithoutPropertiesLoose(_ref, ["indeterminate"]);

  var defaultRef = React.useRef();
  var resolvedRef = ref || defaultRef;
  React.useEffect(function () {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({
    type: "checkbox",
    ref: resolvedRef
  }, rest)));
});

var Table = function Table(_ref2) {
  var data = _ref2.data,
      columns = _ref2.columns,
      _ref2$defaultSorted = _ref2.defaultSorted,
      defaultSorted = _ref2$defaultSorted === void 0 ? [] : _ref2$defaultSorted,
      _ref2$paging = _ref2.paging,
      paging = _ref2$paging === void 0 ? false : _ref2$paging,
      sx = _ref2.sx,
      _ref2$actions = _ref2.actions,
      actions = _ref2$actions === void 0 ? [] : _ref2$actions,
      onSortChanged = _ref2.onSortChanged,
      _ref2$compact = _ref2.compact,
      compact = _ref2$compact === void 0 ? false : _ref2$compact,
      _ref2$manualSortBy = _ref2.manualSortBy,
      manualSortBy = _ref2$manualSortBy === void 0 ? false : _ref2$manualSortBy;

  var _useTable = useTable({
    columns: columns,
    data: data,
    autoResetSortBy: !onSortChanged,
    initialState: {
      sortBy: defaultSorted,
      pageSize: 20
    },
    manualSortBy: manualSortBy
  }, useSortBy, usePagination, useRowSelect, function (hooks) {
    if (!actions.length) return;
    hooks.visibleColumns.push(function (x) {
      return [// Let's make a column for selection
      {
        id: 'selection',
        // The header can use the table's getToggleAllRowsSelectedProps method
        // to render a checkbox
        Header: function Header(_ref3) {
          var getToggleAllRowsSelectedProps = _ref3.getToggleAllRowsSelectedProps;
          return React.createElement("div", null, React.createElement(IndeterminateCheckbox, Object.assign({}, getToggleAllRowsSelectedProps())));
        },
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: function Cell(_ref4) {
          var row = _ref4.row;
          return React.createElement("div", null, React.createElement(IndeterminateCheckbox, Object.assign({}, row.getToggleRowSelectedProps())));
        }
      }].concat(x);
    });
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      page = _useTable.page,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow,
      selectedFlatRows = _useTable.selectedFlatRows,
      toggleAllRowsSelected = _useTable.toggleAllRowsSelected,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      _useTable$state$sortB = _useTable$state.sortBy,
      sortBy = _useTable$state$sortB === void 0 ? [] : _useTable$state$sortB,
      canPreviousPage = _useTable.canPreviousPage,
      canNextPage = _useTable.canNextPage,
      pageCount = _useTable.pageCount,
      previousPage = _useTable.previousPage,
      nextPage = _useTable.nextPage,
      gotoPage = _useTable.gotoPage,
      pageOptions = _useTable.pageOptions,
      setPageSize = _useTable.setPageSize;

  React.useEffect(function () {
    if (onSortChanged) onSortChanged(sortBy);
  }, [sortBy]);
  var paginationOptions = {
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    page: page,
    pageCount: pageCount,
    previousPage: previousPage,
    nextPage: nextPage,
    gotoPage: gotoPage,
    pageOptions: pageOptions,
    setPageSize: setPageSize,
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var rowListing = paging ? page : rows;
  var styles = Object.assign({}, {
    borderCollapse: 'collapse',
    width: '100%',
    height: '100%'
  }, sx || {});
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      width: '100%',
      overflowX: 'auto'
    }
  }, React.createElement(Box, Object.assign({
    as: "table"
  }, getTableProps(), {
    sx: styles
  }), React.createElement(Box, {
    as: "thead",
    sx: {
      textAlign: ['center', 'left']
    }
  }, headerGroups.map(function (group) {
    return React.createElement("tr", Object.assign({}, group.getHeaderGroupProps()), group.headers.map(function (column, i) {
      return React.createElement(TableHeader, {
        key: i,
        compact: compact,
        column: column,
        cardTable: false
      });
    }));
  })), React.createElement("tbody", Object.assign({}, getTableBodyProps()), rowListing.map(function (row, index) {
    prepareRow(row);
    return React.createElement(Box, Object.assign({
      as: "tr",
      key: index
    }, row.getRowProps(), {
      sx: {
        '&:hover': {
          bg: 'primary.l4'
        }
      }
    }), row.cells.map(function (cell, cellIndex) {
      return React.createElement(TableCell, {
        cell: cell,
        key: cellIndex,
        compact: compact
      });
    }));
  })), React.createElement(Box, {
    as: "tfoot",
    sx: {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      display: selectedFlatRows.length ? 'table-footer-group' : 'none',
      width: '100%'
    }
  }, React.createElement("tr", null, React.createElement("td", {
    colSpan: columns.length + 1
  }, React.createElement(Card, {
    sx: {
      bg: 'primary.l4',
      minHeight: 48,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      py: 1,
      px: 3,
      display: 'flex',
      alignItems: 'center'
    }
  }, selectedFlatRows.length, " selected |\xA0", React.createElement(ButtonLink, {
    onClick: function onClick() {
      return toggleAllRowsSelected();
    }
  }, "Select all"), React.createElement(Box, {
    sx: {
      display: ['none', 'none', 'block'],
      ml: 4
    }
  }, actions.length >= 1 && React.createElement(Button, {
    onClick: function onClick() {
      return actions[0].onClick(selectedFlatRows);
    },
    variant: "secondary",
    sx: {
      mr: 2
    }
  }, actions[0].label), actions.length > 1 && React.createElement(Menu, {
    variant: "secondary",
    listItems: actions.slice(1).map(function (x) {
      return {
        onSelect: function onSelect() {
          return x.onClick(selectedFlatRows);
        },
        content: x.label
      };
    })
  }, "More", ' ', React.createElement(Icon, {
    variant: "arrow-down",
    "aria-hidden": true,
    size: "sm",
    sx: {
      mr: '-8px',
      my: '-3px'
    }
  }))), React.createElement(Box, {
    sx: {
      display: ['block', 'block', 'none'],
      ml: 3
    }
  }, React.createElement(Menu, {
    variant: "secondary",
    listItems: actions.map(function (x) {
      return {
        onSelect: function onSelect() {
          return x.onClick(selectedFlatRows);
        },
        content: x.label
      };
    })
  }, "More", ' ', React.createElement(Icon, {
    variant: "arrow-down",
    "aria-hidden": true,
    size: "sm",
    sx: {
      mr: '-8px'
    }
  }))), React.createElement(Button, {
    variant: "ghost",
    onClick: function onClick() {
      return toggleAllRowsSelected(false);
    },
    sx: {
      ml: 'auto'
    }
  }, React.createElement(Icon, {
    variant: "times",
    title: "Deselect all",
    size: "sm"
  })))))))), paging && React.createElement(Pagination, Object.assign({}, paginationOptions)));
};

var IndeterminateCheckbox$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
      rest = _objectWithoutPropertiesLoose(_ref, ["indeterminate"]);

  var defaultRef = React.useRef();
  var resolvedRef = ref || defaultRef;
  React.useEffect(function () {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({
    type: "checkbox",
    ref: resolvedRef
  }, rest)));
});

var Table$1 = function Table(_ref2) {
  var data = _ref2.data,
      columns = _ref2.columns,
      onRowClicked = _ref2.onRowClicked,
      _ref2$defaultSorted = _ref2.defaultSorted,
      defaultSorted = _ref2$defaultSorted === void 0 ? [] : _ref2$defaultSorted,
      _ref2$paging = _ref2.paging,
      paging = _ref2$paging === void 0 ? false : _ref2$paging,
      sx = _ref2.sx,
      _ref2$actions = _ref2.actions,
      actions = _ref2$actions === void 0 ? [] : _ref2$actions,
      onSortChanged = _ref2.onSortChanged,
      _ref2$compact = _ref2.compact,
      compact = _ref2$compact === void 0 ? false : _ref2$compact,
      _ref2$manualSortBy = _ref2.manualSortBy,
      manualSortBy = _ref2$manualSortBy === void 0 ? false : _ref2$manualSortBy;

  var _useTable = useTable({
    columns: columns,
    data: data,
    autoResetSortBy: !onSortChanged,
    initialState: {
      sortBy: defaultSorted,
      pageSize: 20
    },
    manualSortBy: manualSortBy
  }, useSortBy, usePagination, useRowSelect, function (hooks) {
    if (!actions.length) return;
    hooks.visibleColumns.push(function (x) {
      return [// Let's make a column for selection
      {
        id: 'selection',
        // The header can use the table's getToggleAllRowsSelectedProps method
        // to render a checkbox
        Header: function Header(_ref3) {
          var getToggleAllRowsSelectedProps = _ref3.getToggleAllRowsSelectedProps;
          return React.createElement("div", null, React.createElement(IndeterminateCheckbox$1, Object.assign({}, getToggleAllRowsSelectedProps())));
        },
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: function Cell(_ref4) {
          var row = _ref4.row;
          return React.createElement("div", null, React.createElement(IndeterminateCheckbox$1, Object.assign({}, row.getToggleRowSelectedProps())));
        }
      }].concat(x);
    });
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      page = _useTable.page,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow,
      selectedFlatRows = _useTable.selectedFlatRows,
      toggleAllRowsSelected = _useTable.toggleAllRowsSelected,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      _useTable$state$sortB = _useTable$state.sortBy,
      sortBy = _useTable$state$sortB === void 0 ? [] : _useTable$state$sortB,
      canPreviousPage = _useTable.canPreviousPage,
      canNextPage = _useTable.canNextPage,
      pageCount = _useTable.pageCount,
      previousPage = _useTable.previousPage,
      nextPage = _useTable.nextPage,
      gotoPage = _useTable.gotoPage,
      pageOptions = _useTable.pageOptions,
      setPageSize = _useTable.setPageSize;

  React.useEffect(function () {
    if (onSortChanged) onSortChanged(sortBy);
  }, [sortBy]);
  var paginationOptions = {
    canPreviousPage: canPreviousPage,
    canNextPage: canNextPage,
    page: page,
    pageCount: pageCount,
    previousPage: previousPage,
    nextPage: nextPage,
    gotoPage: gotoPage,
    pageOptions: pageOptions,
    setPageSize: setPageSize,
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var rowListing = paging ? page : rows;
  var styles = Object.assign({}, {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    width: '100%',
    cellSpacing: 0,
    cellPadding: 0,
    height: '100%'
  }, sx || {});
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      width: '100%',
      overflowX: 'auto'
    }
  }, React.createElement(Box, Object.assign({
    as: "table"
  }, getTableProps(), {
    sx: styles,
    // @ts-ignore
    cellSpacing: 0,
    cellPadding: 0
  }), React.createElement(Box, {
    as: "thead",
    sx: {
      textAlign: ['center', 'left']
    }
  }, headerGroups.map(function (group) {
    return React.createElement("tr", Object.assign({}, group.getHeaderGroupProps()), group.headers.map(function (column, i) {
      return React.createElement(TableHeader, {
        key: i,
        column: column,
        compact: compact,
        cardTable: true
      });
    }));
  })), React.createElement(Box, Object.assign({
    as: "tbody"
  }, getTableBodyProps(), {
    sx: {
      'tr:first-of-type > td': {
        pt: 0
      }
    }
  }), rowListing.map(function (row) {
    prepareRow(row);
    return React.createElement(Box, Object.assign({
      as: "tr",
      onClick: function onClick() {
        return onRowClicked(row);
      }
    }, row.getRowProps(), {
      sx: {
        '&:hover > td > div': {
          bg: 'primary.l4',
          cursor: 'pointer'
        },
        td: {
          py: 1,
          width: '100%',
          whiteSpace: 'nowrap',
          '& > div': {
            bg: 'white',
            borderTop: '1px solid',
            py: 3,
            px: 3,
            borderBottom: '1px solid',
            borderColor: 'neutral.l3'
          },
          '&:first-of-type > div': {
            borderLeft: '1px solid',
            borderColor: 'neutral.l3',
            borderTopLeftRadius: 'rounded',
            borderBottomLeftRadius: 'rounded'
          },
          '&:last-of-type > div': {
            borderRight: '1px solid',
            borderColor: 'neutral.l3',
            borderTopRightRadius: 'rounded',
            borderBottomRightRadius: 'rounded'
          }
        }
      }
    }), row.cells.map(function (cell) {
      return React.createElement(Box, Object.assign({
        as: "td"
      }, cell.getCellProps()), React.createElement("div", null, cell.render('Cell')));
    }));
  })), React.createElement(Box, {
    as: "tfoot",
    sx: {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      display: selectedFlatRows.length ? 'table-footer-group' : 'none',
      width: '100%'
    }
  }, React.createElement("tr", null, React.createElement("td", {
    colSpan: columns.length + 1
  }, React.createElement(Card, {
    sx: {
      bg: 'primary.l4',
      minHeight: 48,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      py: 1,
      px: 3,
      display: 'flex',
      alignItems: 'center'
    }
  }, selectedFlatRows.length, " selected |\xA0", React.createElement(ButtonLink, {
    onClick: function onClick() {
      return toggleAllRowsSelected();
    }
  }, "Select all"), React.createElement(Box, {
    sx: {
      display: ['none', 'none', 'block'],
      ml: 4
    }
  }, actions.length >= 1 && React.createElement(Button, {
    onClick: function onClick() {
      return actions[0].onClick(selectedFlatRows);
    },
    variant: "secondary",
    sx: {
      mr: 2
    }
  }, actions[0].label), actions.length > 1 && React.createElement(Menu, {
    variant: "secondary",
    listItems: actions.slice(1).map(function (x) {
      return {
        onSelect: function onSelect() {
          return x.onClick(selectedFlatRows);
        },
        content: x.label
      };
    })
  }, "More", ' ', React.createElement(Icon, {
    variant: "arrow-down",
    "aria-hidden": true,
    size: "sm",
    sx: {
      mr: '-8px',
      my: '-3px'
    }
  }))), React.createElement(Box, {
    sx: {
      display: ['block', 'block', 'none'],
      ml: 3
    }
  }, React.createElement(Menu, {
    variant: "secondary",
    listItems: actions.map(function (x) {
      return {
        onSelect: function onSelect() {
          return x.onClick(selectedFlatRows);
        },
        content: x.label
      };
    })
  }, "More", ' ', React.createElement(Icon, {
    variant: "arrow-down",
    "aria-hidden": true,
    size: "sm",
    sx: {
      mr: '-8px'
    }
  }))), React.createElement(Button, {
    variant: "ghost",
    onClick: function onClick() {
      return toggleAllRowsSelected(false);
    },
    sx: {
      ml: 'auto'
    }
  }, React.createElement(Icon, {
    variant: "times",
    title: "Deselect all",
    size: "sm"
  })))))))), paging && React.createElement(Pagination, Object.assign({}, paginationOptions)));
};

export default Table;
export { Table$1 as CardTable };
//# sourceMappingURL=lumos__table.esm.js.map
